import * as React from "react";
import classnames from "classnames";
import { Hr } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
/* empty css                       */
import { FacetPickerHeader } from "../../../../../../../../../FacetPickers/components/modules/EcommContent/components/FacetPickers/components/FacetPickerHeader.js";
const SingleVariantNode = ({ facetConfig, facetTerm, rightSlot, className }) => {
  const { getLabel } = useIntl();
  const { titleLabelKey, titleLabelKeySingle, showSingleFacetAs } = facetConfig;
  const title = getLabel(titleLabelKeySingle ? titleLabelKeySingle : titleLabelKey);
  const SingleFacetFormatter = facetConfig.singleFacetFormatter;
  const singleFacetTerm = SingleFacetFormatter ? /* @__PURE__ */ React.createElement(SingleFacetFormatter, { facetTerm }) : /* @__PURE__ */ React.createElement("div", null, facetTerm);
  if (showSingleFacetAs === "none" && !rightSlot) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: classnames("single-variant-node", className) }, showSingleFacetAs === "text-with-heading" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FacetPickerHeader, { rightSlot }, title), singleFacetTerm), showSingleFacetAs === "text-without-heading" && /* @__PURE__ */ React.createElement("div", { className: "single-variant-node__without-heading" }, singleFacetTerm, rightSlot), showSingleFacetAs === "none" && rightSlot), /* @__PURE__ */ React.createElement(Hr, null));
};
export {
  SingleVariantNode
};
//# sourceMappingURL=SingleVariantNode.js.map
